import { render, staticRenderFns } from "./CandidateResumes.vue?vue&type=template&id=6f0faf5d&"
import script from "./CandidateResumes.vue?vue&type=script&lang=js&"
export * from "./CandidateResumes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports